import { useCallback } from 'react';
import styled from 'styled-components';

import { RouterLink } from '../../components';
import { HOME_PATH } from '../../router/paths';
import { NavLink } from '@make-software/cspr-ui';

const StyledImage = styled.img(({ theme }) =>
  theme.withMedia({
    ':hover': {
      opacity: 0.8,
    },
  })
);

export const NavLogo = () => {
  const onMiddleClickHandler = useCallback((e) => {
    e.preventDefault();
    if ((e.metaKey && e.button === 0) || e.button === 1) {
      window.open(HOME_PATH);
    }
  }, []);

  return (
    <RouterLink
      to={HOME_PATH}
      render={(props) => (
        <NavLink onMouseDown={onMiddleClickHandler}>
          <StyledImage
            src="/assets/icons/logos/cspr-live-full.svg"
            alt="CSPR.LIVE"
            width={89}
            height={40}
            {...props}
          />
        </NavLink>
      )}
    />
  );
};
